/* global Vue, PREFIX, LOYALTY_API */

import { runAsync } from '../../apps/components/Notifications'
import { AuthService, fetchWithTokenAsync } from '../../AuthService'
import { Price } from '../../classes/Price'
import { formatDateForMaistra, normalizeTimezone } from '../../utils-common'

export default {
  name: 'Reservations',
  template: `
  <div v-if="reservations && reservations.length" class="table-container">
    <table class="loyalty-table loyalty-table--bookings loyalty-table--background-odd">
      <tr>
        <th>{{ $t('reservations.property') }}</th>
        <th>{{ $t('reservations.check') }}</th>
        <th v-if="isRateShown">{{ $t('reservations.rate') }}</th>
        <th>{{ $t('reservations.status') }}</th>
      </tr>
      <tr v-for="(r, index) in reservations">
        <td v-if="getPropertyTitle(r.phobsId)"><span class="label-text">{{ $t('reservations.bookingRef') }} #{{ r.bookingReference }}</span><br>{{ getPropertyTitle(r.phobsId).groupTitle }}</td>
        <td v-else><span class="label-text">{{ $t('reservations.bookingRef') }} #{{ r.bookingReference }}</span><br>{{ $t('reservations.noPropertyTitle') }} {{ r.phobsId }}</td>
        <td>{{ formatDateForMaistra(normalizeTimezone(r.arrivalDate)) }} - {{ formatDateForMaistra(normalizeTimezone(r.departureDate)) }}</td>
        <td v-if="isRateShown"><span class="label-text">{{ $t('reservations.memberRate') }}</span><br>{{ r.totalValue.display }}</td>
        <td><span class="uppercase">{{ r.canceled === 0 ? $t('notCanceled') : $t('canceled')}}</span></td>
      </tr>
    </table>
  </div>
  <div
    v-if="reservations && reservations.length === 0"
    class="bookings__no-reservations">
    <p class="large-text no-margin">{{ $t('reservations.noReservations') }} {{ $t('reservations.newHolidays') }}</p>
    <a class="button button--maistar" href="#/check-rates">{{ $t('reservations.checkRates') }}</a>
  </div>
  `,
  emits: ['error'],
  props: {
    active: Boolean,
    isRateShown: Boolean,
    limit: Number,
    loyaltyId: Number,
    properties: Array,
  },
  setup (props, { emit }) {
    const reservations = Vue.ref(null)

    function getPropertyTitle (phobsId) {
      if (phobsId) return props.properties?.find(p => p.phobsId === phobsId)
      return null
    }

    async function loadReservationsAsync () {
      if (!props.loyaltyId) {
        return
      }
      const status = props.active ? '0' : '1' // 0 = active; 1 = past?
      reservations.value = null
      const responseReservations = await fetchWithTokenAsync(`${LOYALTY_API}/api/v1/contacts/myReservations?page=0&status=${status}`, AuthService.accessToken, 'GET')
      if (!responseReservations?.reservations) {
        throw Error('myReservations')
      }
      reservations.value = responseReservations.reservations.map(reservation => ({
        ...reservation,
        totalValue: new Price(reservation.totalValue ?? 0, 'EUR'),
        arrivalDate: new Date(reservation.arrivalDate),
        departureDate: new Date(reservation.departureDate),
      }))
    }

    const { loyaltyId, limit, active } = Vue.toRefs(props)

    Vue.watch(loyaltyId, async () => await runAsync(loadReservationsAsync, true), { immediate: true })
    Vue.watch(limit, async () => await runAsync(loadReservationsAsync, true), { immediate: true })
    Vue.watch(active, async () => await runAsync(loadReservationsAsync, true), { immediate: true })

    return {
      reservations,
      getPropertyTitle,
      PREFIX,
      normalizeTimezone,
      formatDateForMaistra,
    }
  },
}
